import React from 'react';
import { InstagramPost } from '../types';
import { Link } from 'react-router-dom';
import { Insta1, Insta2, Insta3, Insta4, Insta5, Insta6 } from '../images';
  
const Instagram = () => {
    const posts: InstagramPost[] = [
      { id: 1, image: Insta1, link: 'https://www.instagram.com/obesauce/' },
      { id: 2, image: Insta2, link: 'https://www.instagram.com/obesauce/' },
      { id: 3, image: Insta3, link: 'https://www.instagram.com/obesauce/' },
      { id: 4, image: Insta4, link: 'https://www.instagram.com/obesauce/' },
      { id: 5, image: Insta5, link: 'https://www.instagram.com/obesauce/' },
      { id: 6, image: Insta6, link: 'https://www.instagram.com/obesauce/' },
    ];
  
    return (
      <section className="instagram position-relative">
        <div className="d-flex justify-content-center w-100 position-absolute bottom-0 z-1">
          <Link to="#" className="btn btn-dark px-5">Follow us on Instagram</Link>
        </div>
        <div className="row g-0">
          {posts.map(post => (
            <div key={post.id} className="col-6 col-sm-4 col-md-2">
              <div className="insta-item">
                <Link to={post.link} target="_blank" rel="noopener noreferrer">
                  <img src={post.image} alt="instagram" className="insta-image img-fluid" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
};
  
export default Instagram;